import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from './ui/Button';

const SignatureModal = ({ sigCanvasRef, isOpen, onClose, onSubmit, existingSignature }) => {

    const handleClear = () => {
        sigCanvasRef.current.clear();
    };

    const handleSubmit = () => {
        if (!sigCanvasRef.current.isEmpty()) {
            const signatureDataURL = sigCanvasRef.current.toDataURL('image/png');
            onSubmit(signatureDataURL);
        } 
    };

    return (
        <div
            className={`modal ${isOpen ? 'fade show' : ''}`}
            style={{
                display: isOpen ? 'block' : 'none',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Please sign below inside the signature pad</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body text-center">
                        <SignatureCanvas
                            ref={sigCanvasRef}
                            penColor="black"
                            canvasProps={{
                                width: 700,
                                height: 300,
                                className: 'signature-canvas',
                                style: {
                                    border: '2px solid #E0E0E0',
                                    borderRadius: '10px',
                                },
                            }}
                            defaultValue={existingSignature}
                        />
                    </div>
                    <div className="modal-footer d-flex justify-content-end mt-30">
                        <Button label="SUBMIT" status="primary" type="submit" className='me-2' onClick={handleSubmit} />
                        <Button label="RESET" className="btn btn-warning" type="button" onClick={handleClear} />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SignatureModal;
